module.exports = `:root {
  --primitiveColorNeutral0: #000000;
  --primitiveColorNeutral210: #333333;
  --primitiveColorNeutral440: #696969;
  --primitiveColorNeutral690: #a8a8a8;
  --primitiveColorNeutral950: #f0f0f0;
  --primitiveColorNeutral1000: #ffffff;
  --primitiveColorFunctionalPlus550: #349651;
  --primitiveColorFunctionalMinus460: #d70000;
  --primitiveColorOrange630: #ff6200;
  --primitiveColorIndigo370: #525199;
  --primitiveColorIndigo640: #9898c3;
  --primitiveColorIndigo820: #cbcce1;
  --primitiveColorIndigo910: #e6e5f0;
  --primitiveTypographyFontFamily: 'ING Me', Arial, sans-serif;
  --primitiveTypographyTypescale1: 2.125rem;
  --primitiveTypographyTypescale2: 2rem;
  --primitiveTypographyTypescale3: 1.5rem;
  --primitiveTypographyTypescale4: 1.125rem;
  --primitiveTypographyTypescale5: 1rem;
  --primitiveTypographyTypescale6: 0.875rem;
}
`;